export default {
  sended_ics: [],
  received_ics: [],
}
